import { ModulesMap } from '@/config/data/modulesMaps'

import ApiModule from '@/services/apiModule.js'

export default class FieldsTagsApi extends ApiModule {
	constructor() {
		super(ModulesMap.FIELDS_TAGS, {
			entity: 'fields_tags',
		})
	}
}
